<template>
    <router-link :to="l.say(props.link)" :class="[override_class_native, l.say(props.class)]" @click=onClick>
        <i v-if="props.icon" :class='props.icon' aria-hidden="true"></i>
        <span v-if="props.text" v-html="l.say(props.text)"></span>
    </router-link>
</template>

<script setup>
  import { defineProps } from "vue";
  import Language        from '@/js/Shared/Language/Language.js';
  import ClientLoggingControllerSingleton from "@/js/Webmail/ClientLogging/ClientLoggingController";

  const l     = Language;
  const props = defineProps({
    text : {
      type    : String,
      default : null,
    },

    class: {
      type    : String,
      default : null,
    },

    override_class_native: {
      type    : String,
      default : 'button',
    },

    icon: {
      type    : String,
      default : null
    },

    link : {
      required : false,
    },
  })

  const onClick = (event) => {
    ClientLoggingControllerSingleton.addEntry({
      type: 'router-button-click',
      text: props.text || event.currentTarget.getAttribute('data-text') || 'no-text',
    });
  }
</script>